export enum ACTION {
  RESET_PASSWORD = "resetPassword",
  RECOVER_EMAIL = "recoverEmail",
  VERIFY_EMAIL = "verifyEmail",
}
